import customEventSnippets from './customEventSnippets'
import loadAnalyticsData from './loadAnalyticsData'

function createCustomEvent(name, data) {
  const snippet = customEventSnippets[name]
  const payload = snippet && data ? snippet(data) : {}

  loadAnalyticsData(payload)
}

export default createCustomEvent
